import { createContext } from "react";

const loc = window.location;

const env = createContext({
	pro: {
		host: loc.origin
	},
	dev: {
		proto: loc.protocol
	}
});

export default env;
